import { GeoDataDto, MapInfoDto } from "./ProjectMapInfo";
import { TenantDto } from "./TenantDto";

export class ProjectGeoData {
    geodata!: GeoDataDto;
    projects!: ProjectDto[];
}

export class GeoProjectData {
    geodata!: GeoDataDto;
    projects!: ProjectDto[];
}

export class ProjectsDto{
    pageSize!: number;
    totalCount!: number;
    projects!: ProjectDto[];
}

export class WPO2CreateProjectRequest {  
   WPO2_TENANT!: string;  
   WPO2_SERVERURL!: string;  
}

export class WPO2Project {  
   NAME!: string;  
   WPO2_PROJECTID!: string;  
   WPO2_SERVERURL!: string;  
   WPO2_TENANT!: string;  
}

export class ProjectDto {
    id!: string;   
    name!: string;
    url!: string;
    longitude!:number;
    latitude!:number;
    description!:string;
    color!:string;
    icon!:string;
    locationData!:string;
    geoData!:MapInfoDto;
    display_Name!:string;
    wpProjectId!: string;
    tenantName!:string;
    serverName!:string;
    archivedWhen!:string;
    bookedModules!:string;
}

export class ProjectInfo {
    projectName!: string;
    sq3ProjectId!: string;
    environmentId!: string;
    projectId!: string;
    wpProjectId!: string;
    backendUrls: string[] = [];
}

export class ProjectToAdd{
    id!: string;   
    tenantId!:string;
    tenantName!:string;
    name!: string;
    url!: string;
    longitude!:number;
    latitude!:number;
    description!:string;
    color!:string;
    serverName!:string;
    adminUserId!:string[];
    wpProjectId!: string;
    wpTenant!: string;
    wpServerUrl!: string;
    wpApiUser!: string;
    wpApiKey!: string;
    projRolePairs!: string[];
}

export class ProjectResolved{
    projectDto!: ProjectDto;
    error?:any;
}

export class CloneProjectDto{
    projectId!:string;
    name!:string;
    url!:string;
    inclProjGroupRoles!: boolean;
    inclProjUsers!: boolean;
    inclContent!: boolean;
}
export class ArchiveProjectDto{
    projectId!:string;
    archiveComment!:string;
}

export class UpdateProjectResponse
{
    currentVersion!:string;
    isOk!: boolean;
    isRunning!: boolean;
    isError!: boolean;
    message!:string;
}


